import {
  GET_BANKDATA,
  GET_BANKDATA_SUCCESS,
  GET_BANKDATA_FAIL,
  DELETE_BANKDATA,
  DELETE_BANKDATA_SUCCESS,
  DELETE_BANKDATA_FAIL,
  UPDATE_BANKDATA,
  UPDATE_BANKDATA_SUCCESS,
  UPDATE_BANKDATA_FAIL,
  ADD_NEW_BANKDATA,
  ADD_BANKDATA_SUCCESS,
  ADD_BANKDATA_FAIL,
  BANKDATA_LOADING,
} from "./actionType";

export const getBankDataSuccess = (actionType, data) => ({
  type: GET_BANKDATA_SUCCESS,
  payload: { actionType, data },
});

export const getBankDataFail = (actionType, error) => ({
  type: GET_BANKDATA_FAIL,
  payload: { actionType, error },
});

export const getBankData = data => ({
  type: GET_BANKDATA,
  payload: data,
});

export const getBankDataLoading = () => ({
  type: BANKDATA_LOADING
});

export const deleteBankData = data => ({
  type: DELETE_BANKDATA,
  payload: data,
});

export const deleteBankDataSuccess = data => ({
  type: DELETE_BANKDATA_SUCCESS,
  payload: data,
});

export const deleteBankDataFail = error => ({
  type: DELETE_BANKDATA_FAIL,
  payload: error,
});

export const updateBankData = data => ({
  type: UPDATE_BANKDATA,
  payload: data,
});

export const updateBankDataFail = error => ({
  type: UPDATE_BANKDATA_FAIL,
  payload: error,
});

export const updateBankDataSuccess = data => ({
  type: UPDATE_BANKDATA_SUCCESS,
  payload: data,
});

export const addNewBankData = data => ({
  type: ADD_NEW_BANKDATA,
  payload: data,
});

export const addBankDataSuccess = data => ({
  type: ADD_BANKDATA_SUCCESS,
  payload: data,
});

export const addBankDataFail = error => ({
  type: ADD_BANKDATA_FAIL,
  payload: error,
});